export { default as NewsStories } from "./NewsStories.vue"